import { render, staticRenderFns } from "./CongratulationsBanner.vue?vue&type=template&id=5c3293c4&scoped=true"
import script from "./CongratulationsBanner.vue?vue&type=script&lang=js"
export * from "./CongratulationsBanner.vue?vue&type=script&lang=js"
import style0 from "./CongratulationsBanner.vue?vue&type=style&index=0&id=5c3293c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3293c4",
  null
  
)

export default component.exports